/* Ledion · portada con fotos y vídeos (sections/ledion-hero-slides.liquid).
   Funde las diapositivas, reproduce solo el vídeo visible y mueve la barra de progreso.
   Un vídeo más largo que el tiempo por foto se queda hasta que acaba. Con «reducir movimiento»
   empieza en pausa. */
(() => {
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (root) => {
    if (root.dataset.ldReady) return;
    root.dataset.ldReady = '1';
    const slides = [...root.querySelectorAll('[data-ld-hs-slide]')];
    const bars = [...root.querySelectorAll('[data-ld-go]')];
    const pauseBtn = root.querySelector('[data-ld-pause]');
    const base = Math.max(3, parseFloat(root.dataset.seconds) || 7) * 1000;
    let idx = 0;
    let start = performance.now();
    let elapsed = 0;
    let paused = still;
    let visible = true;
    let dur = base;

    const video = (i) => slides[i] && slides[i].querySelector('video');
    const play = (v) => {
      if (!v) return;
      v.muted = true;
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    };

    const durationOf = (i) => {
      const v = video(i);
      return v && isFinite(v.duration) && v.duration > 0 ? Math.max(base, v.duration * 1000) : base;
    };

    const show = (i) => {
      const prev = idx;
      idx = (i + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === idx));
      bars.forEach((b, k) => {
        b.toggleAttribute('aria-current', k === idx);
        b.classList.toggle('is-done', k < idx);
        b.style.setProperty('--p', k < idx ? 1 : 0);
      });
      const pv = video(prev);
      if (pv && prev !== idx) setTimeout(() => pv.pause(), 900);
      const v = video(idx);
      if (v) {
        try {
          v.currentTime = 0;
        } catch (e) {
          /* nada */
        }
        if (!paused) play(v);
      }
      elapsed = 0;
      start = performance.now();
      dur = durationOf(idx);
    };

    const setPaused = (p) => {
      paused = p;
      root.classList.toggle('is-paused', p);
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', p ? pauseBtn.dataset.playLabel || 'Reproducir' : pauseBtn.dataset.pauseLabel || 'Pausar');
      }
      const v = video(idx);
      if (p) {
        elapsed += performance.now() - start;
        if (v) v.pause();
      } else {
        start = performance.now();
        play(v);
      }
    };

    bars.forEach((b) =>
      b.addEventListener('click', () => {
        show(parseInt(b.dataset.ldGo, 10) || 0);
      })
    );
    if (pauseBtn) {
      pauseBtn.dataset.pauseLabel = pauseBtn.getAttribute('aria-label');
      pauseBtn.dataset.playLabel = root.dataset.playLabel || 'Reproducir';
      pauseBtn.addEventListener('click', () => setPaused(!paused));
    }
    slides.forEach((s, k) => {
      const v = s.querySelector('video');
      if (v) v.addEventListener('loadedmetadata', () => k === idx && (dur = durationOf(k)));
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((en) => {
        visible = en[0].isIntersecting;
        const v = video(idx);
        if (v) visible && !paused ? play(v) : v.pause();
      }).observe(root);
    }

    root.classList.add('is-ready');
    if (still) setPaused(true);
    show(0);
    if (slides.length < 2) return;

    const tick = () => {
      if (!paused && visible && !document.hidden) {
        const t = elapsed + performance.now() - start;
        const p = Math.min(1, t / dur);
        if (bars[idx]) bars[idx].style.setProperty('--p', p);
        if (p >= 1) show(idx + 1);
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-ld-hs]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const root = e.target.closest('[data-ld-hs]');
    if (!root) return;
    const i = [...root.querySelectorAll('[data-ld-hs-slide]')].indexOf(e.target);
    const b = root.querySelector(`[data-ld-go="${i}"]`);
    if (b) b.click();
  });
})();
